<!-- 跳转百家中间页 -->
<template>
  <div class="all">
    <h2>即将离开中文知识网</h2>
    <p>您即将进入百科在线，点击“继续访问”可查看具体内容。</p>
    <p>
      中文知识网是国家知识服务平台融合出版分平台，是中文集团旗下子公司运营的知识服务平台。中文知识网拥有百家在线、百科在线、同行评议等子平台。请放心跳转。
    </p>
    <div class="bottom">
      <div class="button" @click="openbaike()">继续访问</div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 打开百科在线页面
    openbaike() {
      let dev = `http://dev.cnknowledge.com/details?ids=${this.$route.query.id}`;
      let pro = `https://www.baikezaixian.com/details?ids=${this.$route.query.id}`;
      // let url = process.env.NODE_ENV === "development" ? dev : pro;
      let url =
        location.host.indexOf("test.") != -1 ||
        location.host.indexOf(":80") != -1
          ? dev
          : pro;
      window.location.href = url;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
};
</script>
<style lang='scss' scoped>
.all {
  color: #333;
  padding: 60px 20px;
  height: 100vh;
  position: relative;
  h2 {
    text-align: center;
    margin-bottom: 50px;
  }
  p {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 20px;
  }
  .bottom {
    position: absolute;
    bottom: 60px;
    left: 50%;
    transform: translate(-50%, -50%);
    .button {
      width: 150px;
      height: 50px;
      background: #0048fd;
      color: #fff;
      text-align: center;
      line-height: 50px;
    }
  }
}
</style>